//  ______                        _               _  _  _
//  |  _  \                      | |             | |(_)| |
//  | | | |  ___    _ __    ___  | |_    ___   __| | _ | |_
//  | | | | / _ \  | '_ \  / _ \ | __|  / _ \ / _` || || __|
//  | |/ / | (_) | | | | || (_) || |_  |  __/| (_| || || |_
//  |___/   \___/  |_| |_| \___/  \__|  \___| \__,_||_| \__|
//
// Generated by skir-typescript-gen
// Home: https://github.com/gepheum/skir-typescript-gen
//
// To install the Skir client library:
//   npm i skir-client

/// <reference types="./calendar_extractions.d.ts" />

import * as $ from "skir-client";

// -----------------------------------------------------------------------------
// enum CalendarEventExtractions.MeetingPreparationContent
// -----------------------------------------------------------------------------

/**
 * Deeply immutable.
 *
 * @alias CalendarEventExtractions.MeetingPreparationContent
 */
class CalendarEventExtractions_MeetingPreparationContent extends $._EnumBase {}

function createValueOfCalendarEventExtractions_MeetingPreparationContent(initializer) {
  const { kind, value } = initializer;
  switch (kind) {
    case "research_brief": {
      return MeetingResearchBrief.create(value);
    }
    case "previous_meetings": {
      return MeetingPreparationNotes.create(value);
    }
  }
}

// -----------------------------------------------------------------------------
// struct CalendarEventExtractions.MeetingPreparation
// -----------------------------------------------------------------------------

/**
 * Deeply immutable. If you need mutability, use `CalendarEventExtractions.MeetingPreparation.Mutable`.
 *
 * @alias CalendarEventExtractions.MeetingPreparation
 */
class CalendarEventExtractions_MeetingPreparation extends $._FrozenBase {}

function initCalendarEventExtractions_MeetingPreparation(target, initializer) {
  target.content = CalendarEventExtractions_MeetingPreparationContent.create(initializer.content ?? CalendarEventExtractions_MeetingPreparationContent.UNKNOWN);
  target.generationTime = initializer.generationTime ?? $.Timestamp.UNIX_EPOCH;
  target.inputHash = initializer.inputHash ?? BigInt(0);
  target.toSkip = initializer.toSkip ?? false;
  target.lastMeetingCheck = initializer.lastMeetingCheck ?? $.Timestamp.UNIX_EPOCH;
  target.prepEmailSentUserIds = $._toFrozenArray(
    initializer.prepEmailSentUserIds || []);
    target.prepSlackSentUserIds = $._toFrozenArray(
      initializer.prepSlackSentUserIds || []);
      target.prepEmailSentForStartTime = initializer.prepEmailSentForStartTime ?? null;
      target.prepSlackSentForStartTime = initializer.prepSlackSentForStartTime ?? null;
}

// -----------------------------------------------------------------------------
// struct CalendarEventExtractions.Attendee
// -----------------------------------------------------------------------------

/**
 * Deeply immutable. If you need mutability, use `CalendarEventExtractions.Attendee.Mutable`.
 *
 * @alias CalendarEventExtractions.Attendee
 */
class CalendarEventExtractions_Attendee extends $._FrozenBase {}

function initCalendarEventExtractions_Attendee(target, initializer) {
  target.email = initializer.email ?? "";
  target.displayName = initializer.displayName ?? "";
  target.isInternal = initializer.isInternal ?? false;
  target.organizer = initializer.organizer ?? false;
  target.declined = initializer.declined ?? false;
}

// -----------------------------------------------------------------------------
// struct CalendarEventExtractions
// -----------------------------------------------------------------------------

/** Deeply immutable. If you need mutability, use `CalendarEventExtractions.Mutable`. */
export class CalendarEventExtractions extends $._FrozenBase {}

function initCalendarEventExtractions(target, initializer) {
  target.meetingPreparation = initializer.meetingPreparation ? CalendarEventExtractions_MeetingPreparation.create(initializer.meetingPreparation) : null;
  target.attendees = $._toFrozenArray(
    initializer.attendees || [],
    CalendarEventExtractions_Attendee.create,
  );
}

// -----------------------------------------------------------------------------
// struct ParticipantSummary
// -----------------------------------------------------------------------------

/** Deeply immutable. If you need mutability, use `ParticipantSummary.Mutable`. */
export class ParticipantSummary extends $._FrozenBase {}

function initParticipantSummary(target, initializer) {
  target.name = initializer.name ?? "";
  target.email = initializer.email ?? "";
  target.role = initializer.role ?? "";
  target.company = initializer.company ?? "";
  target.linkedinUrl = initializer.linkedinUrl ?? "";
  target.summary = initializer.summary ?? "";
  target.isNew = initializer.isNew ?? false;
}

// -----------------------------------------------------------------------------
// struct MeetingResearchBrief.TopConversationStarter
// -----------------------------------------------------------------------------

/**
 * Deeply immutable. If you need mutability, use `MeetingResearchBrief.TopConversationStarter.Mutable`.
 *
 * @alias MeetingResearchBrief.TopConversationStarter
 */
class MeetingResearchBrief_TopConversationStarter extends $._FrozenBase {}

function initMeetingResearchBrief_TopConversationStarter(target, initializer) {
  target.text = initializer.text ?? "";
}

// -----------------------------------------------------------------------------
// struct MeetingResearchBrief.KeyOpportunity
// -----------------------------------------------------------------------------

/**
 * Deeply immutable. If you need mutability, use `MeetingResearchBrief.KeyOpportunity.Mutable`.
 *
 * @alias MeetingResearchBrief.KeyOpportunity
 */
class MeetingResearchBrief_KeyOpportunity extends $._FrozenBase {}

function initMeetingResearchBrief_KeyOpportunity(target, initializer) {
  target.text = initializer.text ?? "";
}

// -----------------------------------------------------------------------------
// struct MeetingResearchBrief.MeetingPrepNote
// -----------------------------------------------------------------------------

/**
 * Deeply immutable. If you need mutability, use `MeetingResearchBrief.MeetingPrepNote.Mutable`.
 *
 * @alias MeetingResearchBrief.MeetingPrepNote
 */
class MeetingResearchBrief_MeetingPrepNote extends $._FrozenBase {}

function initMeetingResearchBrief_MeetingPrepNote(target, initializer) {
  target.text = initializer.text ?? "";
}

// -----------------------------------------------------------------------------
// struct MeetingResearchBrief.SupportingDetail
// -----------------------------------------------------------------------------

/**
 * Deeply immutable. If you need mutability, use `MeetingResearchBrief.SupportingDetail.Mutable`.
 *
 * @alias MeetingResearchBrief.SupportingDetail
 */
class MeetingResearchBrief_SupportingDetail extends $._FrozenBase {}

function initMeetingResearchBrief_SupportingDetail(target, initializer) {
  target.text = initializer.text ?? "";
}

// -----------------------------------------------------------------------------
// struct MeetingResearchBrief.Source
// -----------------------------------------------------------------------------

/**
 * Deeply immutable. If you need mutability, use `MeetingResearchBrief.Source.Mutable`.
 *
 * @alias MeetingResearchBrief.Source
 */
class MeetingResearchBrief_Source extends $._FrozenBase {}

function initMeetingResearchBrief_Source(target, initializer) {
  target.id = initializer.id ?? 0;
  target.title = initializer.title ?? "";
  target.url = initializer.url ?? "";
}

// -----------------------------------------------------------------------------
// struct MeetingResearchBrief
// -----------------------------------------------------------------------------

/** Deeply immutable. If you need mutability, use `MeetingResearchBrief.Mutable`. */
export class MeetingResearchBrief extends $._FrozenBase {}

function initMeetingResearchBrief(target, initializer) {
  target.executiveSummary = initializer.executiveSummary ?? "";
  target.topConversationStarters = $._toFrozenArray(
    initializer.topConversationStarters || [],
    MeetingResearchBrief_TopConversationStarter.create,
  );
  target.keyOpportunities = $._toFrozenArray(
    initializer.keyOpportunities || [],
    MeetingResearchBrief_KeyOpportunity.create,
  );
  target.meetingPrepNotes = $._toFrozenArray(
    initializer.meetingPrepNotes || [],
    MeetingResearchBrief_MeetingPrepNote.create,
  );
  target.supportingDetails = $._toFrozenArray(
    initializer.supportingDetails || [],
    MeetingResearchBrief_SupportingDetail.create,
  );
  target.sources = $._toFrozenArray(
    initializer.sources || [],
    MeetingResearchBrief_Source.create,
  );
  target.participantSummaries = $._toFrozenArray(
    initializer.participantSummaries || [],
    ParticipantSummary.create,
  );
}

// -----------------------------------------------------------------------------
// struct MeetingPreparationNotes.ConversationStarter
// -----------------------------------------------------------------------------

/**
 * Deeply immutable. If you need mutability, use `MeetingPreparationNotes.ConversationStarter.Mutable`.
 *
 * @alias MeetingPreparationNotes.ConversationStarter
 */
class MeetingPreparationNotes_ConversationStarter extends $._FrozenBase {}

function initMeetingPreparationNotes_ConversationStarter(target, initializer) {
  target.topic = initializer.topic ?? "";
  target.opening = initializer.opening ?? "";
  target.context = initializer.context ?? "";
}

// -----------------------------------------------------------------------------
// struct MeetingPreparationNotes.KeyPrepPoint
// -----------------------------------------------------------------------------

/**
 * Deeply immutable. If you need mutability, use `MeetingPreparationNotes.KeyPrepPoint.Mutable`.
 *
 * @alias MeetingPreparationNotes.KeyPrepPoint
 */
class MeetingPreparationNotes_KeyPrepPoint extends $._FrozenBase {}

function initMeetingPreparationNotes_KeyPrepPoint(target, initializer) {
  target.category = initializer.category ?? "";
  target.point = initializer.point ?? "";
  target.context = initializer.context ?? "";
}

// -----------------------------------------------------------------------------
// struct MeetingPreparationNotes.Objection
// -----------------------------------------------------------------------------

/**
 * Deeply immutable. If you need mutability, use `MeetingPreparationNotes.Objection.Mutable`.
 *
 * @alias MeetingPreparationNotes.Objection
 */
class MeetingPreparationNotes_Objection extends $._FrozenBase {}

function initMeetingPreparationNotes_Objection(target, initializer) {
  target.objection = initializer.objection ?? "";
  target.counterPoint = initializer.counterPoint ?? null;
}

// -----------------------------------------------------------------------------
// struct MeetingPreparationNotes
// -----------------------------------------------------------------------------

/** Deeply immutable. If you need mutability, use `MeetingPreparationNotes.Mutable`. */
export class MeetingPreparationNotes extends $._FrozenBase {}

function initMeetingPreparationNotes(target, initializer) {
  target.meetingContext = initializer.meetingContext ?? "";
  target.relationshipSummary = initializer.relationshipSummary ?? "";
  target.conversationStarters = $._toFrozenArray(
    initializer.conversationStarters || [],
    MeetingPreparationNotes_ConversationStarter.create,
  );
  target.keyPrepPoints = $._toFrozenArray(
    initializer.keyPrepPoints || [],
    MeetingPreparationNotes_KeyPrepPoint.create,
  );
  target.followUpOpportunities = $._toFrozenArray(
    initializer.followUpOpportunities || []);
    target.successMetrics = $._toFrozenArray(
      initializer.successMetrics || []);
      target.notesToAvoid = $._toFrozenArray(
        initializer.notesToAvoid || []);
        target.participantSummaries = $._toFrozenArray(
          initializer.participantSummaries || [],
          ParticipantSummary.create,
        );
        target.potentialObjections = $._toFrozenArray(
          initializer.potentialObjections || [],
          MeetingPreparationNotes_Objection.create,
        );
}

// -----------------------------------------------------------------------------
// struct CalendarEventAttendees
// -----------------------------------------------------------------------------

/** Deeply immutable. If you need mutability, use `CalendarEventAttendees.Mutable`. */
export class CalendarEventAttendees extends $._FrozenBase {}

function initCalendarEventAttendees(target, initializer) {
  target.emails = $._toFrozenArray(
    initializer.emails || []);
}

// -----------------------------------------------------------------------------
// Initialize the serializers
// -----------------------------------------------------------------------------

$._initModuleClasses(
  "calendar_extractions.skir",
  [
    {
      kind: "enum",
      ctor: CalendarEventExtractions_MeetingPreparationContent,
      createValueFn: createValueOfCalendarEventExtractions_MeetingPreparationContent,
      name: "MeetingPreparationContent",
      parentCtor: CalendarEventExtractions,
      variants: [
        {
          name: "UNKNOWN",
          number: 0,
        },
        {
          name: "research_brief",
          number: 1,
          type: {
            kind: "record",
            ctor: MeetingResearchBrief,
          },
        },
        {
          name: "previous_meetings",
          number: 2,
          type: {
            kind: "record",
            ctor: MeetingPreparationNotes,
          },
        },
      ],
    },
    {
      kind: "struct",
      ctor: CalendarEventExtractions_MeetingPreparation,
      initFn: initCalendarEventExtractions_MeetingPreparation,
      name: "MeetingPreparation",
      parentCtor: CalendarEventExtractions,
      fields: [
        {
          name: "content",
          property: "content",
          number: 0,
          type: {
            kind: "record",
            ctor: CalendarEventExtractions_MeetingPreparationContent,
          },
        },
        {
          name: "generation_time",
          property: "generationTime",
          number: 1,
          type: {
            kind: "primitive",
            primitive: "timestamp",
          },
        },
        {
          name: "input_hash",
          property: "inputHash",
          number: 2,
          type: {
            kind: "primitive",
            primitive: "int64",
          },
        },
        {
          name: "to_skip",
          property: "toSkip",
          number: 3,
          type: {
            kind: "primitive",
            primitive: "bool",
          },
        },
        {
          name: "last_meeting_check",
          property: "lastMeetingCheck",
          number: 4,
          type: {
            kind: "primitive",
            primitive: "timestamp",
          },
        },
        {
          name: "prep_email_sent_user_ids",
          property: "prepEmailSentUserIds",
          number: 6,
          type: {
            kind: "array",
            item: {
              kind: "primitive",
              primitive: "string",
            },
          },
          mutableGetter: "mutablePrepEmailSentUserIds",
        },
        {
          name: "prep_slack_sent_user_ids",
          property: "prepSlackSentUserIds",
          number: 7,
          type: {
            kind: "array",
            item: {
              kind: "primitive",
              primitive: "string",
            },
          },
          mutableGetter: "mutablePrepSlackSentUserIds",
        },
        {
          name: "prep_email_sent_for_start_time",
          property: "prepEmailSentForStartTime",
          number: 8,
          type: {
            kind: "optional",
            other: {
              kind: "primitive",
              primitive: "timestamp",
            },
          },
        },
        {
          name: "prep_slack_sent_for_start_time",
          property: "prepSlackSentForStartTime",
          number: 9,
          type: {
            kind: "optional",
            other: {
              kind: "primitive",
              primitive: "timestamp",
            },
          },
        },
      ],
      removedNumbers: [
        5,
      ],
    },
    {
      kind: "struct",
      ctor: CalendarEventExtractions_Attendee,
      initFn: initCalendarEventExtractions_Attendee,
      name: "Attendee",
      parentCtor: CalendarEventExtractions,
      fields: [
        {
          name: "email",
          property: "email",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "display_name",
          property: "displayName",
          number: 1,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "is_internal",
          property: "isInternal",
          number: 2,
          type: {
            kind: "primitive",
            primitive: "bool",
          },
        },
        {
          name: "organizer",
          property: "organizer",
          number: 3,
          type: {
            kind: "primitive",
            primitive: "bool",
          },
        },
        {
          name: "declined",
          property: "declined",
          number: 4,
          type: {
            kind: "primitive",
            primitive: "bool",
          },
        },
      ],
    },
    {
      kind: "struct",
      ctor: CalendarEventExtractions,
      initFn: initCalendarEventExtractions,
      name: "CalendarEventExtractions",
      fields: [
        {
          name: "meeting_preparation",
          property: "meetingPreparation",
          number: 0,
          type: {
            kind: "optional",
            other: {
              kind: "record",
              ctor: CalendarEventExtractions_MeetingPreparation,
            },
          },
        },
        {
          name: "attendees",
          property: "attendees",
          number: 1,
          type: {
            kind: "array",
            item: {
              kind: "record",
              ctor: CalendarEventExtractions_Attendee,
            },
          },
          mutableGetter: "mutableAttendees",
        },
      ],
    },
    {
      kind: "struct",
      ctor: ParticipantSummary,
      initFn: initParticipantSummary,
      name: "ParticipantSummary",
      fields: [
        {
          name: "name",
          property: "name",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "email",
          property: "email",
          number: 1,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "role",
          property: "role",
          number: 2,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "company",
          property: "company",
          number: 3,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "linkedin_url",
          property: "linkedinUrl",
          number: 4,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "summary",
          property: "summary",
          number: 5,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "is_new",
          property: "isNew",
          number: 6,
          type: {
            kind: "primitive",
            primitive: "bool",
          },
        },
      ],
    },
    {
      kind: "struct",
      ctor: MeetingResearchBrief_TopConversationStarter,
      initFn: initMeetingResearchBrief_TopConversationStarter,
      name: "TopConversationStarter",
      parentCtor: MeetingResearchBrief,
      fields: [
        {
          name: "text",
          property: "text",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
      ],
    },
    {
      kind: "struct",
      ctor: MeetingResearchBrief_KeyOpportunity,
      initFn: initMeetingResearchBrief_KeyOpportunity,
      name: "KeyOpportunity",
      parentCtor: MeetingResearchBrief,
      fields: [
        {
          name: "text",
          property: "text",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
      ],
    },
    {
      kind: "struct",
      ctor: MeetingResearchBrief_MeetingPrepNote,
      initFn: initMeetingResearchBrief_MeetingPrepNote,
      name: "MeetingPrepNote",
      parentCtor: MeetingResearchBrief,
      fields: [
        {
          name: "text",
          property: "text",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
      ],
    },
    {
      kind: "struct",
      ctor: MeetingResearchBrief_SupportingDetail,
      initFn: initMeetingResearchBrief_SupportingDetail,
      name: "SupportingDetail",
      parentCtor: MeetingResearchBrief,
      fields: [
        {
          name: "text",
          property: "text",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
      ],
    },
    {
      kind: "struct",
      ctor: MeetingResearchBrief_Source,
      initFn: initMeetingResearchBrief_Source,
      name: "Source",
      parentCtor: MeetingResearchBrief,
      fields: [
        {
          name: "id",
          property: "id",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "int32",
          },
        },
        {
          name: "title",
          property: "title",
          number: 1,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "url",
          property: "url",
          number: 2,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
      ],
    },
    {
      kind: "struct",
      ctor: MeetingResearchBrief,
      initFn: initMeetingResearchBrief,
      name: "MeetingResearchBrief",
      fields: [
        {
          name: "executive_summary",
          property: "executiveSummary",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "top_conversation_starters",
          property: "topConversationStarters",
          number: 1,
          type: {
            kind: "array",
            item: {
              kind: "record",
              ctor: MeetingResearchBrief_TopConversationStarter,
            },
          },
          mutableGetter: "mutableTopConversationStarters",
        },
        {
          name: "key_opportunities",
          property: "keyOpportunities",
          number: 2,
          type: {
            kind: "array",
            item: {
              kind: "record",
              ctor: MeetingResearchBrief_KeyOpportunity,
            },
          },
          mutableGetter: "mutableKeyOpportunities",
        },
        {
          name: "meeting_prep_notes",
          property: "meetingPrepNotes",
          number: 3,
          type: {
            kind: "array",
            item: {
              kind: "record",
              ctor: MeetingResearchBrief_MeetingPrepNote,
            },
          },
          mutableGetter: "mutableMeetingPrepNotes",
        },
        {
          name: "supporting_details",
          property: "supportingDetails",
          number: 4,
          type: {
            kind: "array",
            item: {
              kind: "record",
              ctor: MeetingResearchBrief_SupportingDetail,
            },
          },
          mutableGetter: "mutableSupportingDetails",
        },
        {
          name: "sources",
          property: "sources",
          number: 5,
          type: {
            kind: "array",
            item: {
              kind: "record",
              ctor: MeetingResearchBrief_Source,
            },
          },
          mutableGetter: "mutableSources",
        },
        {
          name: "participant_summaries",
          property: "participantSummaries",
          number: 6,
          type: {
            kind: "array",
            item: {
              kind: "record",
              ctor: ParticipantSummary,
            },
          },
          mutableGetter: "mutableParticipantSummaries",
        },
      ],
    },
    {
      kind: "struct",
      ctor: MeetingPreparationNotes_ConversationStarter,
      initFn: initMeetingPreparationNotes_ConversationStarter,
      name: "ConversationStarter",
      parentCtor: MeetingPreparationNotes,
      fields: [
        {
          name: "topic",
          property: "topic",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "opening",
          property: "opening",
          number: 1,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "context",
          property: "context",
          number: 2,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
      ],
    },
    {
      kind: "struct",
      ctor: MeetingPreparationNotes_KeyPrepPoint,
      initFn: initMeetingPreparationNotes_KeyPrepPoint,
      name: "KeyPrepPoint",
      parentCtor: MeetingPreparationNotes,
      fields: [
        {
          name: "category",
          property: "category",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "point",
          property: "point",
          number: 1,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "context",
          property: "context",
          number: 2,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
      ],
    },
    {
      kind: "struct",
      ctor: MeetingPreparationNotes_Objection,
      initFn: initMeetingPreparationNotes_Objection,
      name: "Objection",
      parentCtor: MeetingPreparationNotes,
      fields: [
        {
          name: "objection",
          property: "objection",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "counter_point",
          property: "counterPoint",
          number: 1,
          type: {
            kind: "optional",
            other: {
              kind: "primitive",
              primitive: "string",
            },
          },
        },
      ],
    },
    {
      kind: "struct",
      ctor: MeetingPreparationNotes,
      initFn: initMeetingPreparationNotes,
      name: "MeetingPreparationNotes",
      fields: [
        {
          name: "meeting_context",
          property: "meetingContext",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "relationship_summary",
          property: "relationshipSummary",
          number: 1,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "conversation_starters",
          property: "conversationStarters",
          number: 2,
          type: {
            kind: "array",
            item: {
              kind: "record",
              ctor: MeetingPreparationNotes_ConversationStarter,
            },
          },
          mutableGetter: "mutableConversationStarters",
        },
        {
          name: "key_prep_points",
          property: "keyPrepPoints",
          number: 3,
          type: {
            kind: "array",
            item: {
              kind: "record",
              ctor: MeetingPreparationNotes_KeyPrepPoint,
            },
          },
          mutableGetter: "mutableKeyPrepPoints",
        },
        {
          name: "follow_up_opportunities",
          property: "followUpOpportunities",
          number: 4,
          type: {
            kind: "array",
            item: {
              kind: "primitive",
              primitive: "string",
            },
          },
          mutableGetter: "mutableFollowUpOpportunities",
        },
        {
          name: "success_metrics",
          property: "successMetrics",
          number: 6,
          type: {
            kind: "array",
            item: {
              kind: "primitive",
              primitive: "string",
            },
          },
          mutableGetter: "mutableSuccessMetrics",
        },
        {
          name: "notes_to_avoid",
          property: "notesToAvoid",
          number: 7,
          type: {
            kind: "array",
            item: {
              kind: "primitive",
              primitive: "string",
            },
          },
          mutableGetter: "mutableNotesToAvoid",
        },
        {
          name: "participant_summaries",
          property: "participantSummaries",
          number: 8,
          type: {
            kind: "array",
            item: {
              kind: "record",
              ctor: ParticipantSummary,
            },
          },
          mutableGetter: "mutableParticipantSummaries",
        },
        {
          name: "potential_objections",
          property: "potentialObjections",
          number: 9,
          type: {
            kind: "array",
            item: {
              kind: "record",
              ctor: MeetingPreparationNotes_Objection,
            },
          },
          mutableGetter: "mutablePotentialObjections",
        },
      ],
      removedNumbers: [
        5,
      ],
    },
    {
      kind: "struct",
      ctor: CalendarEventAttendees,
      initFn: initCalendarEventAttendees,
      name: "CalendarEventAttendees",
      fields: [
        {
          name: "emails",
          property: "emails",
          number: 0,
          type: {
            kind: "array",
            item: {
              kind: "primitive",
              primitive: "string",
            },
          },
          mutableGetter: "mutableEmails",
        },
      ],
    },
  ]
);
